import React from 'react';
const QuickTourSvg = ({ color = 'white', className, onClick, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g id="Frame 1437253195">
        <g id="tour">
          <path
            id="Vector"
            d="M11.9998 5.88889C8.62471 5.88889 5.88867 8.62493 5.88867 12C5.88867 13.6638 6.55359 15.1723 7.63218 16.2744C8.05231 16.7036 8.39766 17.2144 8.51551 17.8034L9.16219 21.0352C9.39079 22.1777 10.394 23 11.5592 23H12.4404C13.6055 23 14.6087 22.1777 14.8374 21.0352L15.4841 17.8034C15.6019 17.2144 15.9472 16.7036 16.3674 16.2744C17.446 15.1723 18.1109 13.6638 18.1109 12C18.1109 8.62493 15.3748 5.88889 11.9998 5.88889Z"
            stroke={color}
            strokeWidth="1.5"
          />
          <path
            id="Vector_2"
            d="M12 2.22222V1"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_3"
            d="M19.333 4.66667L20.5552 3.44444"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_4"
            d="M21.7773 12H22.9996"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_5"
            d="M2.22222 12H1"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_6"
            d="M3.44434 3.44444L4.66656 4.66667"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_7"
            d="M9.55566 18.1111H14.4446"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

export default QuickTourSvg;
